export default __webpack_public_path__ + "static/media/4449.25bf9db6.png";